import comp from "./Portal";
export default comp;
